import ReactDOM from 'react-dom/client';
import IconModt from '@/components/iconModt';
import { customStyles, deleteDOM, noOpenModal } from '@/service/api';
import App from '@/App';
import { Suspense } from 'react';
import { formEventV2 } from '@/service/formEventV2';
import { STORAGE_KEY } from '@/constant/constant';
import { getLocal, setLocal, setSession } from '@/utils/storage';

const showIcon = (upgradeLoad) => {
  // 悬浮窗跨页跟随逻辑：如果有临时弹窗配置则渲染 icon
  const triggerPop = getLocal(STORAGE_KEY.TEMP_POP);
  if (triggerPop) {
    // 从本地配置中取配置
    const responseData = JSON.parse(triggerPop || '{}');
    const settings = responseData.settings;

    // 埋点
    formEventV2({
      event: 'float_ad_view',
      triggerEventType: responseData.triggerEventType ?? 0,
      formId: responseData.id ?? '',
      formName: responseData.name ?? ''
    })
      .then((response) => {
        // console.log('数据上报成功')
      })
      .catch((e) => {});

    const div = document?.createElement('div');
    div.id = 'cartx-icon';
    window?.document?.body?.appendChild(div);

    const root = ReactDOM.createRoot(div);
    root.render(
      <IconModt
        position={settings.position}
        show={true}
        setShow={() => {
          // 没有弹窗显示
          if (noOpenModal()) {
            // console.log('弹出真正弹窗');
            document?.querySelector('#cartx-icon')?.remove();
            // 当前悬浮窗的配置
            const popIcon = getLocal(STORAGE_KEY.TEMP_POP);
            if (popIcon) {
              // 标记本次弹窗来自 icon 点击，埋点 showFrom 用
              setLocal(STORAGE_KEY.SHOW_FROM, 'click');
              // 清除0、4弹窗，防止当前已触发且等待显示时dom冲突
              deleteDOM('cartx-wrap');
              // 清除加购弹窗
              deleteDOM('cartx-purchase-wrap');

              const config = JSON.parse(popIcon || '{}');

              const response = { data: { data: config } };
              // 当前展示的弹窗 id 写 session，用于请求层拦截重复下发
              setSession(STORAGE_KEY.POP_SHOW, config.id);
              // 弹出
              const div = document.createElement('div');
              div.className = 'cartx-mount-wrap';
              if (config.triggerEventType == 2) {
                //加购订阅
                div.id = 'cartx-purchase-wrap';
                customStyles(response, '#cartx-purchase-wrap');
              } else {
                // 0、4
                div.id = 'cartx-wrap';
                customStyles(response, '#cartx-wrap');
              }
              window?.document?.body?.appendChild(div);
              const rootNode = document.getElementById(div.id);
              const root = ReactDOM.createRoot(rootNode);
              root.render(
                <Suspense fallback={<div>...</div>}>
                  <App
                    settings={response.data.data?.settings ?? {}}
                    type={response.data.data?.type ?? ''}
                    expand={response.data.data?.expand ?? false}
                    id={response.data.data?.id ?? ''}
                    combinationType={response.data.data?.combinationType ?? ''}
                    triggerEventType={response.data.data?.triggerEventType ?? ''}
                    responseData={response.data.data}
                    externalRes={''}
                    upgradeLoad={upgradeLoad}
                    extraTime={0}
                    actionType={response.data.data?.triggerEventType ?? ''}
                    name={response.data.data?.name ?? ''}
                    loadStartTime={0}
                    coverShow={responseData?.coverShow ?? false}
                  />
                </Suspense>
              );
            }
          }
        }}
        triggerEventType={responseData.triggerEventType}
        id={responseData.id ?? ''}
        name={responseData.name ?? ''}
      />
    );
  }
};

export { showIcon };
